const PROCESSING_PERCENT = 0.019;
const PROCESSING_FIXED_CENTS = 25;
const ROUNDING_CENTS = 10;

// A pre-sale estimate of VaultGrid's published organizer tariff. The amount
// actually invoiced is calculated from each completed card payment on the server.
export const estimateOrganizerProcessingTariff = (paymentAmount) => {
  const amount = Number(paymentAmount);
  if (!Number.isFinite(amount) || amount <= 0) return 0;
  const amountCents = Math.round(amount * 100);
  const rawFeeCents = Math.round(amountCents * PROCESSING_PERCENT + PROCESSING_FIXED_CENTS);
  return (Math.ceil(rawFeeCents / ROUNDING_CENTS) * ROUNDING_CENTS) / 100;
};

export const getTicketCardPaymentAmounts = (ticketPrice, depositPercent = 100) => {
  const priceCents = Math.round(Number(ticketPrice) * 100);
  if (!Number.isFinite(priceCents) || priceCents <= 0) return [];
  const percent = Number(depositPercent);
  if (!Number.isFinite(percent) || percent <= 0 || percent >= 100) {
    return [priceCents / 100];
  }
  const depositCents = Math.round((priceCents * percent) / 100);
  const balanceCents = priceCents - depositCents;
  return [depositCents / 100, balanceCents / 100];
};

export const estimateTicketProcessingTariff = (ticketPrice, depositPercent = 100) => {
  const payments = getTicketCardPaymentAmounts(ticketPrice, depositPercent);
  return {
    total: payments.reduce(
      (sum, amount) => sum + estimateOrganizerProcessingTariff(amount),
      0
    ),
    paymentCount: payments.length,
  };
};
